<template>
  <div class="text-start" :class="{ flex: horizontal }">
    <h2 class="za-text-title self-end" :class="{'mb-2': !horizontal, 'mr-2': horizontal}">{{ title }}</h2>
    <h3 class="za-text-subtitle self-end">{{ subtitle }}</h3>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  subtitle: string;
  horizontal?: boolean;
}>();
</script>
